// extracted by mini-css-extract-plugin
export default {"media-image":"Media_media-image__Cduvg","media-description":"Media_media-description__TqS7w"};